import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import classnames from "classnames";

import OfferIcons from "@components/icons/Offer";

export default observer(function BetBuilderPicksFilterBar() {
	const rootStore = useRootAppStore();
	if (
		rootStore.quickPlayStore.betBuilderPicksStore.sportCategories.length ==
		1
	) {
		return null;
	}

	return (
		<div className="u-mar--bottom--big">
			<nav className="tabs--secondary">
				{rootStore.quickPlayStore.betBuilderPicksStore.sportCategories.map(
					(sport) => {
						const buttonClasses = classnames(
							"tabs--secondary__item btn btn--sml btn--auto btn--icon u-mar--right--med",
							{
								"btn--tertiary":
									rootStore.quickPlayStore
										.betBuilderPicksStore
										.selectedSportCategory?.sportAbrv !=
									sport.sportAbrv,
								"btn--secondary is-active":
									rootStore.quickPlayStore
										.betBuilderPicksStore
										.selectedSportCategory?.sportAbrv ==
									sport.sportAbrv,
							}
						);

						const iconClasses = classnames(
							"tabs--secondary__circle u-icon--big",
							{
								"is-active":
									rootStore.quickPlayStore
										.betBuilderPicksStore
										.selectedSportCategory?.sportAbrv ==
									sport.sportAbrv,
							}
						);

						return (
							<button
								className={buttonClasses}
								onClick={() =>
									rootStore.quickPlayStore.betBuilderPicksStore.filterByCategory(
										sport.sportAbrv
									)
								}
								key={sport.sportAbrv}
							>
								<span className={iconClasses}>
									<OfferIcons
										type="sport"
										sport={sport.sportAbrv || ""}
										className="tabs--secondary__icon u-icon u-icon--xmed"
									/>
								</span>
								<span>{sport.sportName}</span>
							</button>
						);
					}
				)}
			</nav>
		</div>
	);
});
